<template>
  <div class="case-detail-container">
    <!-- 图片展示区域 - 长图拼接 -->
    <div class="long-image-wrapper" v-if="imageUrls.length > 0">
      <div class="long-image-container">
        <div
            v-for="(url, index) in imageUrls"
            :key="index"
            class="image-item"
        >
          <el-image
              :src="url"
              :alt="`${caseData.name}-${index + 1}`"
              fit="contain"
              class="single-image"
              :preview-src-list="imageUrls"
              :initial-index="index"
          >
            <template #error>
              <div class="image-error">
                <el-icon><Picture /></el-icon>
                <span>图片加载失败</span>
              </div>
            </template>
            <template #placeholder>
              <div class="image-loading">
                <el-icon class="is-loading"><Loading /></el-icon>
                <span>图片加载中...</span>
              </div>
            </template>
          </el-image>
        </div>
      </div>
    </div>
    <div v-else class="no-image-placeholder">
      <el-icon><Picture /></el-icon>
      <span>暂无图片</span>
    </div>

    <!-- 案例内容区域 -->
    <div class="case-info-container">
      <div class="case-name">
        <h1>{{ caseData.name }}</h1>
        <p class="case-date">日期：{{ caseData.date }}</p>
      </div>
      <div class="case-description">
        <div v-html="caseData.describeOne"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Picture, Loading } from '@element-plus/icons-vue'
import serverApi from "@/api/server";

export default {
  name: 'CaseDetail',
  components: {
    Picture,
    Loading
  },
  data() {
    return {
      caseData: {
        id: 1,
        name: '智慧城市大数据可视化平台',
        imgUrl: '',
        describeOne: '',
        date: '2023-05-15'
      },
      imageUrls: []
    }
  },
  created() {
    this.getProductById(this.$route.query.id);
  },
  methods: {
    getProductById(productId) {
      serverApi.getCaseById(productId).then(res => {
        this.caseData = res.data.data;
        console.log(res.data);
        if (this.caseData.imgUrl) {
          this.imageUrls = this.caseData.imgUrl.split(',').map(url => url.trim());
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.case-detail-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}

/* 长图容器样式 */
.long-image-wrapper {
  margin: 50px 0 40px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background-color: #f8f9fa;
}

.long-image-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.image-item {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.single-image {
  width: 100%;
  display: block;
}

/* 图片加载状态样式 */
.image-error,
.image-loading,
.no-image-placeholder {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  background-color: #f8f9fa;

  .el-icon {
    font-size: 40px;
    margin-bottom: 10px;
    color: #c0c4cc;
  }
}

/* 案例内容区域 */
.case-info-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px 40px;
}

.case-name {
  margin-bottom: 30px;

  h1 {
    font-size: 32px;
    color: #222;
    margin-bottom: 15px;
    font-weight: 600;
    line-height: 1.3;
  }
}

.case-date {
  color: #666;
  font-size: 15px;
}

.case-description {
  line-height: 1.8;
  color: #444;
  font-size: 16px;

  :deep {
    h3 {
      color: #222;
      margin: 30px 0 20px;
      font-size: 22px;
      font-weight: 500;
      padding-bottom: 8px;
      border-bottom: 1px solid #eee;
    }

    p {
      margin-bottom: 20px;
    }

    ul, ol {
      padding-left: 24px;
      margin-bottom: 20px;
    }

    li {
      margin-bottom: 10px;
    }

    a {
      color: #409eff;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #66b1ff;
        text-decoration: underline;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .long-image-wrapper {
    margin: 30px 0;
    padding: 10px;
  }

  .case-name h1 {
    font-size: 26px;
  }

  .case-description {
    font-size: 15px;

    :deep h3 {
      font-size: 20px;
    }
  }
}

@media (max-width: 480px) {
  .case-name h1 {
    font-size: 22px;
  }
}
</style>
